import * as ActionTypes from '../../../constants';
import { listProjects } from '../../../firebase/projects';
import { startLoader, stopLoader } from '../reducers/loading';
import { showToast, setToastText } from './toast';

const fetchProjects = (username, successType) => (dispatch, getState) => {
  dispatch(startLoader());

  // No `:username` route param means the logged-in user's own dashboard.
  const targetUsername = username || getState().user.username;

  return listProjects(targetUsername)
    .then(({ projects }) => {
      dispatch({ type: successType, projects });
      dispatch(stopLoader());
      return projects;
    })
    .catch((error) => {
      // ActionTypes.ERROR has no reducer (silent failure) — surface a toast so a failed dashboard
      // load (permission-denied, offline, missing index) isn't an indistinguishable empty list.
      dispatch(stopLoader());
      dispatch(showToast(5500));
      dispatch(setToastText('Could not load sketches. Please try again.'));
    });
};

export const getProjects = (username) =>
  fetchProjects(username, ActionTypes.SET_PROJECTS);
